import React from "react";
import convert from "convert-units";
import lround from "lodash/round";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import moment from "moment";
import PropTypes from "prop-types";
import submit from "submit-form";
import { PARAMETER_OPTIONS } from "../../constants";
import {
  prevalidateSet,
  validateExercise,
  validateSet,
  prevalidateOtherSet,
  validateAssistantSet,
} from "../../utils/exercise-validations";
import UnitInput from "../inputs/unit-input-add-exercise";
import Modal from "../modal-new";
import { mapParameter } from "../other-exercise/CustomParametersSets";
import { setIntervalX } from "../../utils/annual-planner-helpers";
import { getPermissionNamesByIds } from "../../views/dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import AddLibraryExercise from "./add_edit_exercise/AddLibraryExercise";
import { SearchDropdown } from "../inputs/search-dropdown";
import SvgIcon from "../SvgIcon";
import EditSetRow from "./add_edit_exercise/EditSetRow";
import AddExerciseSets from "./add_edit_exercise/AddExerciseSets";
import AddSetRow from "./add_edit_exercise/AddSetRow";

const { SETS, REPS, RPEAMRAP, LOAD, NONE } = PARAMETER_OPTIONS;

class AddExerciseModal extends React.Component {
  // newSet.load and newSet.equippedRepMax are always the same units as the user's preferred display units
  // defaultRepMax is always stored in kg
  constructor(props, context) {
    super(props, context);
    this.locals = context.locals;
    this.activeUser =
      cloneDeep(this.locals.athlete) ||
      cloneDeep(this.locals.activeUserToRequest);
    this.activeUser.preferredLoadInput =
      this.locals.activeUserToRequest.preferredLoadInput;

    this.editExercise = cloneDeep(this.props.editExercise);
    this.sessionId = parseInt(context.locals.query.session)
      ? context.locals.query.session
      : get(context.locals.query.session, "order");
    this.editExerciseMode = context.locals.query.editMode;

    let defaultRepMax = 0;
    let defaultSecondaryRepMax = 0;
    let secondaryValue = "";

    if (this.editExerciseMode) {
      if (this.editExercise?.type === "primary") {
        secondaryValue = `${this.editExercise.primary}`;
        defaultRepMax = get(
          this.editExercise,
          `repMaximums.${this.editExercise.primary || "squat"}`,
          100
        );
      } else if (this.editExercise?.type === "secondary") {
        secondaryValue = `${this.editExercise.secondary}{${this.editExercise.primary}}`;

        // Getting defaultRepMax because it is used for adding new secondaries
        defaultRepMax = get(
          this.editExercise,
          `repMaximums.${this.editExercise.primary || "squat"}`,
          100
        );
        if (this.editExercise.secondaryRepMaximum) {
          defaultSecondaryRepMax = this.editExercise.secondaryRepMaximum;
        } else {
          const movement = this.activeUser.exerciseLibrary[
            this.editExercise.primary
          ].find((item) => item.movement === this.editExercise.secondary);
          defaultSecondaryRepMax = movement.repMaximum;
        }
      } else {
        secondaryValue = `${this.editExercise?.secondary}{${this.editExercise?.primary}}`;
      }
    } else {
      defaultRepMax = get(this.activeUser, `repMaximums.squat`, 0);
    }

    this.state = {
      selectInput: "",
      addingFromSelect: false,
      form: {
        primary: this.editExerciseMode ? this.editExercise.primary : "squat",
        secondary: this.editExerciseMode ? secondaryValue.split("{")[0] : "",
        secondaryValue: this.editExerciseMode ? secondaryValue : "",
        exerciseMovement: this.editExerciseMode
          ? this.editExercise.secondary
          : "",
        sets: this.editExerciseMode ? this.editExercise.sets : [],
        type: this.editExerciseMode ? this.editExercise.type : "secondary",
        notes: this.editExerciseMode ? this.editExercise.notes : "",
        repMaximums: this.editExerciseMode
          ? this.editExercise.repMaximums
          : get(this.activeUser, `repMaximums`, {
              squat: 0,
              bench: 0,
              deadlift: 0,
            }),
        secondaryRepMaximum: defaultSecondaryRepMax,
        cycle: this.editExerciseMode
          ? this.editExercise.cycle
          : {
              id: get(
                context.locals.params,
                "cycleId",
                context.locals.query.cycle
              ),
              isScheduled: false,
              program: context.locals.query.program,
              programWeek:
                context.locals.query.programWeek || context.locals.query.week,
              programSession:
                context.locals.query.programSession || this.sessionId,
            },
        notes: this.editExerciseMode ? this.editExercise.notes : "",
        basicExerciseType: "basicExercise",
      },
      defaultRepMax: defaultRepMax,
      newSet: {
        units: {
          defaultRepMax: this.locals.activeUser.units,
          load: this.locals.activeUser.units,
          equippedRepMax: this.locals.activeUser.units,
        },
      },
      isNewSetValid: false,
      editSet: {
        units: {
          defaultRepMax: this.locals.activeUser.units,
          load: this.locals.activeUser.units,
          equippedRepMax: this.locals.activeUser.units,
        },
      },
      editExerciseMode: this.editExerciseMode,
      preferredLoadInput: get(this.activeUser, "preferredLoadInput", "percent"),
      updateRMPrompt: false,
      newSecondaryUnit: this.locals.activeUser.units,
      // states for adding exercise's fields
      newExerciseFields: {
        parameters: [SETS, REPS, RPEAMRAP, LOAD],
        freeFormSelected: null,
        videoUrl: "",
        videoFile: null,
        videoOriginal: "", // if there is an uploaded video
        exerciseTypeField: "",
        primaryMuscleGroup: "",
        secondaryMuscleGroup: "",
        instructions: "",
      },
      parametersForm: {
        sets: "",
        rounds: "",
        reps: "",
        rpe: "",
        time: "",
        distance: "",
        load: "",
        rest: "",
        velocity: "",
        freeform: "",
      },
      newMovement: "",
      submited: false,
      error: false,
    };
    this.handleEditSetChange = this.handleEditSetChange.bind(this);
    this.handleRemoveSet = this.handleRemoveSet.bind(this);
    this.handleUpdateSet = this.handleUpdateSet.bind(this);
    this.handleSetEditModeToggle = this.handleSetEditModeToggle.bind(this);
    this.handleUnitChange = this.handleUnitChange.bind(this);
    this.confirmLeavePage = this.confirmLeavePage.bind(this);
    this.updateRM = this.updateRM.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRMChange = this.handleRMChange.bind(this);
    this.handleSaveToLibrary = this.handleSaveToLibrary.bind(this);
    this.buildMovementOptionsArray = this.buildMovementOptionsArray.bind(this);
    this.updateOtherExerciseParameters =
      this.updateOtherExerciseParameters.bind(this);
    this.handleNewFieldsInputChange =
      this.handleNewFieldsInputChange.bind(this);
    this.finishSaveToLibrary = this.finishSaveToLibrary.bind(this);
    this.handleParameterInputChange =
      this.handleParameterInputChange.bind(this);
    this.handleReorderSet = this.handleReorderSet.bind(this);
    this.handleNewSetChange = this.handleNewSetChange.bind(this);
    this.handleAddSet = this.handleAddSet.bind(this);
  }

  componentDidMount() {
    const {
      query: { editMode, exercise },
      editExercises,
      activeExercises,
    } = this.context.locals;

    const arr = editExercises || activeExercises;
    if (editMode && exercise && arr) {
      const selectedExercise = arr.find((elem) => elem._id === exercise);
      this.setState({ selectedExercise });
    }
  }

  componentDidUpdate(prevProps) {
    // if a new exercise is added to the assistant library
    const { lengthAssistantLibrary, secondaryAdded } = this.props;
    if (lengthAssistantLibrary !== prevProps.lengthAssistantLibrary) {
      const target = {
        name: "secondaryValue",
        value: this.state.form.secondary,
        primary: "assistant",
        type: "assistant",
        newMovementRM: 0,
      };

      this.handleChange({ target });
    } else if (secondaryAdded && secondaryAdded !== prevProps.secondaryAdded) {
      const target = {
        name: "secondaryValue",
        value: this.state.form.secondary,
        primary: this.state.form.primary,
        type: "secondary",
        newMovementRM: this.state.form.secondaryRepMaximum,
      };
      this.handleChange({ target });
    }
  }

  updateOtherExerciseParameters(parameters, freeFormSelected) {
    this.setState((prevState) => ({
      newExerciseFields: {
        ...prevState.newExerciseFields,
        parameters,
        freeFormSelected,
      },
    }));
  }

  handleChange(e) {
    const { name, value, movementPrimary, type, newMovementRM } = e.target;
    const { newSet, form: constForm } = this.state;
    let { form, defaultRepMax } = this.state;

    const primary =
      name === "exerciseMovement" && constForm.primary
        ? movementPrimary
        : constForm.primary;

    form[name] = value.split("{")[0];
    form["primary"] = primary;

    if (name === "basicExerciseType" && value === "powerliftingExercise") {
      defaultRepMax = 100;
    }

    if (name === "exerciseMovement") {
      if (type === "primary") {
        form["type"] = "primary";

        // updates the repMaximum based on the new primary e.g changing from 'squat' to 'bench'
        defaultRepMax = form.repMaximums[primary] || 100;
        // updates repMaximum that displays on the form
        if (document.getElementById("defaultRepmaxUnitInput")) {
          document.getElementById("defaultRepmaxUnitInput").value = this.locals
            .activeUserToRequest.round
            ? lround(
                convert(defaultRepMax)
                  .from("kg")
                  .to(newSet.units.defaultRepMax === "imperial" ? "lb" : "kg"),
                0
              )
            : lround(
                convert(defaultRepMax)
                  .from("kg")
                  .to(newSet.units.defaultRepMax === "imperial" ? "lb" : "kg"),
                2
              );
        }
      } else if (type === "secondary") {
        form["type"] = "secondary";
        form["secondary"] = value.split("{")[0];
        form["secondaryValue"] = value;

        /**if the user doesn't have that value in the exercise library, we are going to create the property with
         * an empty array to push the exercise there, this is for weird cases where the users doesnt have that exercise.primary
         * value in the exercise library. EXAMPLE:
         * user.exerciseLibrary = {squat: ..., assistant: ..., deadlift: ...] here doesn't exists "bench"
         * So if an user tries to add a bench variaty in the exercise library this is going to fail because we are pushing an
         * exercise in a undefined value instead in an array.
         **/
        if (
          !this.activeUser.exerciseLibrary[primary] &&
          [
            "assistant",
            "squat",
            "bench",
            "deadlift",
            "clean",
            "jerk",
            "snatch",
            "overheadPress",
            "other",
          ].includes(primary)
        ) {
          this.activeUser.exerciseLibrary[primary] = [];
        }
        const movement = this.activeUser.exerciseLibrary[primary].find(
          (item) => item.movement === form.exerciseMovement
        );

        if (movement) {
          form = Object.assign(form, {
            secondaryRepMaximum:
              movement.repMaximum || this.state.defaultRepMax,
          });
        } else if (this.locals.athlete) {
          form = Object.assign(form, {
            secondaryRepMaximum: form.repMaximums[form.primary] || 100,
          });
        }

        if (document.getElementById("defaultRepmaxUnitInput")) {
          document.getElementById("defaultRepmaxUnitInput").value = this.locals
            .activeUserToRequest.round
            ? lround(
                convert(form.secondaryRepMaximum)
                  .from("kg")
                  .to(newSet.units.defaultRepMax === "imperial" ? "lb" : "kg"),
                0
              )
            : lround(
                convert(form.secondaryRepMaximum)
                  .from("kg")
                  .to(newSet.units.defaultRepMax === "imperial" ? "lb" : "kg"),
                2
              );
        }
      } else {
        form["type"] = "assistant";
      }
    }

    if (name === "secondaryValue") {
      form["secondaryValue"] = value + "{" + primary + "}";
      form["type"] = type;
      form["secondaryRepMaximum"] = newMovementRM;
      form["selectedLabel"] = `${value}${
        type === "secondary" ? ` (${primary})` : ""
      }`;
    }

    if (name === "primary") {
      form["primary"] = value;
      defaultRepMax = form.repMaximums[value] || 100;

      if (document.getElementById("newRMUnitInput")) {
        document.getElementById("newRMUnitInput").value = this.locals
          .activeUserToRequest.round
          ? lround(
              convert(defaultRepMax)
                .from("kg")
                .to(newSet.units.defaultRepMax === "imperial" ? "lb" : "kg"),
              0
            )
          : lround(
              convert(defaultRepMax)
                .from("kg")
                .to(newSet.units.defaultRepMax === "imperial" ? "lb" : "kg"),
              2
            );
      }
    }

    if (name === "notes") {
      return this.setState({
        form,
      });
    }
    const search = form.exerciseMovement || value;
    if (!this.context.locals.activeUserToRequest.exerciseLibrary[primary]) {
      this.context.locals.activeUserToRequest.exerciseLibrary[primary] = [];
    }
    const selectedExercise =
      this.context.locals.activeUserToRequest.exerciseLibrary[primary].find(
        (elem) => elem.movement === search
      ); // load the selected exercise in the state
    if (
      (selectedExercise && selectedExercise.parameters) ||
      (this.state.selectedExercise && this.state.selectedExercise.parameters)
    ) {
      form.sets = [];
    }

    if (name === "basicExerciseType" && value === "powerliftingExercise") {
      form.repMaximums = {
        bench: 100,
        deadlift: 100,
        squat: 100,
        clean: 100,
        jerk: 100,
        snatch: 100,
        overheadPress: 100,
        other: 100,
      };
    }

    this.setState({
      form,
      defaultRepMax,
      isNewSetValid: prevalidateSet(
        this.state.newSet,
        form.type === "assistant"
      ),
      selectedExercise,
    });
  }

  handleRMDismiss(e) {
    e.preventDefault();
    // When deciding not to change the Rep maximum, revert back to the default Rep Max
    const defaultInKg = get(
      this.state.form,
      `repMaximums.${this.state.form.primary}`,
      100
    );
    const defaultRepMax = lround(
      convert(defaultInKg)
        .from("kg")
        .to(this.state.newSet.units.defaultRepMax === "imperial" ? "lb" : "kg"),
      2
    );
    document.getElementById("defaultRepmaxUnitInput").value = defaultRepMax;
    this.setState({
      updateEnabled: false,
      updateRMPrompt: false,
      defaultRepMax: defaultInKg,
    });
  }

  handleRMChange(e, where) {
    const form = this.state.form;
    const newSet = this.state.newSet;
    const units = newSet.units["defaultRepMax"] === "metric" ? "kg" : "lb";
    form.secondaryRepMaximum = lround(
      convert(e.target.value).from(units).to("kg"),
      2
    );

    this.setState({ updateEnabled: true, form });
    return false;
  }

  handleRMUpdate(e) {
    e.preventDefault();
    if (
      !confirm("Are you sure you want to update the 1RM for this exercise?")
    ) {
      return;
    }
    // updates repMaximum for this exercise only
    let defaultRepMax = parseFloat(
      document.getElementById("defaultRepmaxUnitInput").value
    );
    // ensure defaultRepMax is stored in KG
    // TODO: defaultRepMax units should be stored on this.state.form instead of newSet/editSet
    if (this.state.newSet.units.defaultRepMax === "imperial")
      defaultRepMax = convert(defaultRepMax).from("lb").to("kg");

    const form = this.state.form;
    form.repMaximums[form.primary] = defaultRepMax;
    this.setState({
      defaultRepMax,
      form,
      updateEnabled: false,
      updateRMPrompt: true,
    });

    this.updateRM(form);
  }

  updateRM(form) {
    const { athlete, activeUser } = this.locals;
    const user = athlete || activeUser;

    submit(`/actions/rep-maximum/update?proxyAthlete=${user._id}`, {
      method: "POST",
      body: form,
    });
  }

  // function will update all future workout RMs
  handleUpdateExerciseRM(form, e) {
    e.preventDefault();
    if (
      !confirm(
        "Are you sure you want to apply the new 1 rep max to all upcoming workouts"
      )
    ) {
      return;
    }
    const { athlete, activeUser } = this.locals;
    const user = athlete || activeUser;
    form.updateFutureRM = true;

    submit(`/actions/rep-maximum/update?proxyAthlete=${user._id}`, {
      method: "POST",
      body: form,
    });

    this.setState({ updateRMPrompt: false });
  }
  // in case user does not want to update all workouts, simply dismiss message
  handleUpdateExerciseRMDismiss(e) {
    e.preventDefault();
    this.setState({ updateRMPrompt: false });
  }

  handleAddSetAssistantWParameters() {
    const { form, selectedExercise, parametersForm } = this.state;
    const { locals } = this.context;
    let newSet = {};
    selectedExercise.parameters.forEach((element) => {
      newSet[mapParameter(element)] = parametersForm[mapParameter(element)];
    });
    if (parametersForm.restTime) newSet.restTime = parametersForm.restTime;
    if (parametersForm.loadDrop) {
      newSet.loadDrop = parametersForm.loadDrop;
      delete newSet.load;
    }

    if (selectedExercise.parameters.includes(REPS)) {
      newSet = validateAssistantSet({ locals, set: newSet });
    }

    if (!newSet) return;

    //form set push
    const cloneForm = cloneDeep(form);
    cloneForm.sets.push(newSet);
    const parameterLoadInput = document.getElementById(`${LOAD}_id_parameter`);

    if (parameterLoadInput) {
      parameterLoadInput.value = 0;
    }

    this.setState({
      form: cloneForm,
      isNewSetValid: false,
      parametersForm: {
        sets: "",
        rounds: "",
        reps: "",
        rpe: "",
        time: "",
        distance: "",
        load: "",
        rest: "",
        velocity: "",
        freeform: "",
        restTime: "",
      },
    });

    // re-focuses on first input

    if (
      document.getElementById(`${selectedExercise.parameters[0]}_id_parameter`)
    )
      document
        .getElementById(`${selectedExercise.parameters[0]}_id_parameter`)
        .focus();
  }

  handleAddSet(e) {
    // Validate newSet and add it to the list of form sets
    e.preventDefault();
    const { selectedExercise } = this.state;
    const { locals } = this.context;
    this.setState({ error: false });
    if (selectedExercise && selectedExercise.parameters) {
      return this.handleAddSetAssistantWParameters();
    }

    const form = this.state.form;
    const newSet = validateSet({
      exercise: form,
      set: this.state.newSet,
      defaultRepMax: this.state.defaultRepMax,
      locals,
    });

    if (newSet) {
      form.sets.push(newSet);
      this.setState({
        form,
        newSet: { units: newSet.units },
        isNewSetValid: false,
      });

      // Reset the Add Set values
      const idsToReset = [
        "exerciseAddSets",
        "exerciseAddReps",
        "exerciseAddRpe",
        "exerciseAddLoad",
        "exerciseAddWeightLoad",
        "exerciseAddLoadDrop",
      ];
      idsToReset.forEach((id) =>
        document.getElementById(id)
          ? (document.getElementById(id).value = "")
          : ""
      );
      // re-focuses on set input
      if (document.getElementById("exerciseAddSets"))
        document.getElementById("exerciseAddSets").focus();
    }
  }

  handleRemoveSet(setIndex) {
    // Remove a set from form sets
    const form = this.state.form;
    form.sets.splice(setIndex, 1);
    this.setState({ form });
    // re-focuses on set input
    if (document.getElementById("exerciseAddSets"))
      document.getElementById("exerciseAddSets").focus();
  }

  handleUpdateSet(setIndex) {
    // Edit a form set
    const form = this.state.form;
    const { locals } = this.context;
    let editSet;
    if (!this.state.selectedExercise) {
      editSet = validateSet({
        exercise: form,
        set: this.state.editSet,
        defaultRepMax: this.state.defaultRepMax,
        locals,
      });
    } else if (this.state.editSet && !this.state.selectedExercise.parameters) {
      editSet = validateSet({
        exercise: form,
        set: this.state.editSet,
        defaultRepMax: this.state.defaultRepMax,
        locals,
      });
    } else if (
      this.state.selectedExercise.parameters &&
      prevalidateOtherSet(this.state.selectedExercise, this.state.editSet)
    ) {
      editSet = this.state.editSet;
    }
    if (editSet) {
      form.sets[setIndex] = editSet;
      form.sets[setIndex].editMode = false;
      this.setState({ form, editingSet: false });
    }
    // re-focuses on set input
    if (document.getElementById("exerciseAddSets"))
      document.getElementById("exerciseAddSets").focus();
  }

  handleNewSetChange(e) {
    const newSet = this.state.newSet;
    const name = e.target.name;
    newSet[name] = e.target.value;
    const isAssistant = this.state.form.type === "assistant";

    // flagging if anything has changed. This is to be used in `onClose` for `Modal`
    let hasSetChanged;
    if (!this.state.hasSetChanged) hasSetChanged = true;

    // forcing user to not input decimal on sets or reps and saving the rounded value
    if (["sets"].includes(name)) {
      newSet[name] = lround(e.target.value);
      e.target.value = newSet[name];
    }

    // forcing user to not input more than two decimal on load or repMax
    if (["load", "repMaximum"].includes(name)) {
      const value = String(e.target.value);
      if (
        value.includes(".") &&
        !value.endsWith(".") &&
        value.split(".")[1].length > 2
      ) {
        e.target.value = lround(parseFloat(value), 2);
      }
    }

    if (
      ["load", "equippedRepMax", "percentRepMax", "loadDrop"].indexOf(name) > -1
    ) {
      if (String(newSet[name]).includes(",")) {
        newSet[name] = e.target.value = String(newSet[name]).replace(/,/g, ".");
      }
      // If making an equipped set, using load percentage of RM, make sure the %RM is of the equipped RM and not the default
      if (newSet.equipped && newSet.equippedRepMax && newSet.percentRepMax) {
        // no conversion needed since both equippedRepMax and load are ensured to be in KG
        newSet.load = (newSet.equippedRepMax * newSet.percentRepMax) / 100;
      }
    }

    if (["load", "equippedRepMax"].indexOf(name) > -1) {
      // enforce load and equippedRepMax to be in KG
      if ("metric" !== this.state.newSet.units[name]) {
        newSet[name] = convert(newSet[name]).from("lb").to("kg");
      }
    }

    // defaults to latest 1RM if no secondaryRM instead of 0
    const repMax = parseFloat(
      (this.state.form.type !== "primary"
        ? this.state.form.secondaryRepMaximum
        : this.state.defaultRepMax) || this.state.defaultRepMax
    );
    // remembers last value (weight or percent) and converts appropriately during toggle
    if (name === "percentRepMax") {
      newSet.load = (repMax * parseFloat(newSet[name])) / 100;
      //ensure display load is converted to the most recently selected unit when switching from percent
      document.getElementById("exerciseAddWeightLoad").value = lround(
        this.state.newSet.units["load"] === "metric"
          ? newSet.load
          : convert(newSet.load).from("kg").to("lb"),
        2
      );
    }
    if (name === "load" && this.state.form.type !== "assistant") {
      // no conversion needed since both defaultRepMax and load are ensured to be in KG
      newSet.percentRepMax = (parseFloat(newSet.load) / repMax) * 100;
      document.getElementById("exerciseAddLoad").value = lround(
        newSet.percentRepMax,
        2
      );
    }

    this.setState((prevState) => {
      return {
        ...prevState,
        newSet,
        isNewSetValid: prevalidateSet(newSet, isAssistant),
        hasSetChanged,
      };
    });
    return false;
  }

  handleEditSetChange(e) {
    e.preventDefault && e.preventDefault();
    let editSet = this.state.editSet;
    if (!editSet) throw new Error("No set to edit");
    const name = e.target.name;
    editSet[name] = e.target.value;
    // flagging if anything has changed. This is to be used in `onClose` for `Modal`
    let hasSetChanged;
    if (!this.state.hasSetChanged) hasSetChanged = true;

    // forcing user to not input decimal on sets or reps and saving the rounded value
    if (["sets"].includes(name)) {
      editSet[name] = lround(e.target.value);
      e.target.value = editSet[name];
    }

    // forcing user to not input more than two decimal on load or repMax
    if (["load", "percentRepMax", "repMaximum"].includes(name)) {
      const value = String(e.target.value);
      if (
        value.includes(".") &&
        !value.endsWith(".") &&
        value.split(".")[1].length > 2
      ) {
        e.target.value = lround(parseFloat(value), 2);
      }
    }

    if (
      ["load", "equippedRepMax", "percentRepMax", "loadDrop"].indexOf(name) > -1
    ) {
      if (String(editSet[name]).includes(",")) {
        editSet[name] = e.target.value = String(editSet[name]).replace(
          /,/g,
          "."
        );
      }
      // If making an equipped set, using load percentage of RM, make sure the %RM is of the equipped RM and not the default
      if (editSet.equipped && editSet.equippedRepMax && editSet.percentRepMax) {
        // no conversion needed since both equippedRepMax and load are ensured to be in KG
        editSet.load = (editSet.equippedRepMax * editSet.percentRepMax) / 100;
      }
    }

    if (
      ["load", "equippedRepMax"].indexOf(name) > -1 &&
      this.state.selectedExercise &&
      !this.state.selectedExercise.parameters
    ) {
      // enforce load and equippedRepMax to be in KG
      if ("metric" !== this.state.editSet.units[name]) {
        editSet[name] = convert(editSet[name]).from("lb").to("kg");
      }
    }

    // defaults to latest 1RM if no secondaryRM instead of 0
    const repMax = parseFloat(
      (this.state.form.type !== "primary"
        ? this.state.form.secondaryRepMaximum
        : this.state.defaultRepMax) || this.state.defaultRepMax
    );
    // remembers last value (weight or percent) and converts appropriately during toggle
    if (name === "percentRepMax") {
      editSet.load = (repMax * parseFloat(editSet[name])) / 100;
      //ensure load is converted to the most recently selected unit when switching from percent
      document.getElementById("exerciseEditWeightLoad").value = lround(
        this.state.editSet.units["load"] === "metric"
          ? editSet.load
          : convert(editSet.load).from("kg").to("lb"),
        2
      );
    }
    if (name === "load" && this.state.form.type !== "assistant") {
      editSet.percentRepMax = (parseFloat(editSet[name]) / repMax) * 100;
      document.getElementById("exerciseEditLoad").value = lround(
        editSet.percentRepMax,
        2
      );
    }
    this.setState({ editSet, hasSetChanged });
  }

  handleSaveToLibrary() {
    const {
      newMovement,
      newMovementRM,
      selectInput,
      addingFromSelect,
      form,
      defaultRepMax,
    } = this.state;

    let newMovementRMValue = defaultRepMax;
    let primaryValue = form.primary;
    let typeValue = "secondary";

    if (
      this.context.locals.athlete &&
      this.activeUser?.repMaximums?.[form.primary]
    ) {
      newMovementRMValue = this.activeUser.repMaximums[form.primary];
    }

    // If its a basic exercise its assistant
    if (form.basicExerciseType === "basicExercise") {
      primaryValue = "assistant";
      typeValue = "assistant";
      newMovementRMValue = 0;
    }

    setTimeout(() => {
      if (
        (selectInput && addingFromSelect) ||
        (newMovement && form.type != "assistant" && newMovementRM) ||
        (newMovement && form.type == "assistant")
      ) {
        this.setState({ addingMovementToLibrary: false });
      }
      this.finishSaveToLibrary(primaryValue, newMovementRMValue, typeValue);
    });
  }

  finishSaveToLibrary(primaryValue, newMovementRMValue, typeValue) {
    const { newSet, newMovement, selectInput, form } = this.state;

    this.setState({
      selectInput: "",
      newMovement: "",
      addingFromSelect: false,
      form: Object.assign(form, {
        primary: primaryValue,
        secondaryRepMaximum: newMovementRMValue,
        secondary: newMovement,
        secondaryValue: newMovement,
        exerciseMovement: newMovement,
      }),
      newExerciseFields: {
        parameters: [SETS, REPS, RPEAMRAP, LOAD],
        freeFormSelected: null,
        videoUrl: "",
        videoFile: null,
        videoOriginal: "", // if there is an uploaded video
        exerciseTypeField: "",
        primaryMuscleGroup: "",
        secondaryMuscleGroup: "",
        instructions: "",
      },
      defaultRepMax: newMovementRMValue,
    });

    const units = newSet.units.defaultRepMax;
    const inputValue =
      units === "imperial"
        ? convert(form.secondaryRepMaximum).from("kg").to("lb")
        : form.secondaryRepMaximum;
    document.getElementById("defaultRepmaxUnitInput").value = lround(
      inputValue,
      2
    );

    const target = {
      name: "secondaryValue",
      value: newMovement || selectInput,
      primary: primaryValue,
      type: typeValue,
      newMovementRM: form.secondaryRepMaximum,
    };

    this.handleChange({ target });
  }

  handleSetEditModeToggle(editSetIndex, initialSetState) {
    // Display the text inputs for a set so you can edit it
    const form = this.state.form;
    form.sets.forEach((set, index) => {
      if (index === editSetIndex || set.editMode === true)
        form.sets[index].editMode = !set.editMode;
      // this is to rollback incomplete edit of set to editSetBackup
      if (index === editSetIndex && initialSetState)
        form.sets[editSetIndex] = initialSetState;
    });
    // backing up editSet
    const editSetBackup = initialSetState
      ? cloneDeep(this.state.editSet)
      : cloneDeep(form.sets[editSetIndex]);
    editSetBackup.editMode = false;
    const editSet = {
      units: {
        defaultRepMax: this.locals.activeUser.units,
        load: this.locals.activeUser.units,
        equippedRepMax: this.locals.activeUser.units,
      },
      ...form.sets[editSetIndex],
      idx: editSetIndex,
    };

    if (editSet.reps && editSet.repsLower) {
      editSet.reps = `${editSet.repsLower}-${editSet.reps}`;
      editSet.repsLower = null;
    }

    this.setState({
      form,
      editSet,
      editSetBackup,
      editingSet: editSet.editMode,
    });
    // re-focuses on set input
    if (document.getElementById("exerciseAddSets"))
      document.getElementById("exerciseAddSets").focus();
  }

  triggerWarning(e) {
    e.preventDefault();
    const addButton = document.getElementsByClassName(
      "add-set-round-button"
    )[0];

    this.setState({
      error: "You must add (+) at least one set before saving the exercise",
    });

    // Call a custom set interval that will execute only 4 times
    // to blink twice the (+) button
    setIntervalX(this.highlightEvent, 300, 4, addButton);
  }

  highlightEvent([addButton]) {
    addButton.classList.toggle("button-highlight");
  }

  handleSubmit(e) {
    // Post all form data
    e.preventDefault();
    if (this.state.submited) return;
    this.setState({ submited: true, error: false });
    if (
      this.state.isNewSetValid &&
      !confirm("Would you like to proceed without adding the filled in set?")
    ) {
      this.setState({ submited: false });
      return;
    }

    const form = cloneDeep(this.state.form);
    let date = this.props.date;
    // get rid of cycle and add date if this is from the calendar
    if (this.props.date) {
      delete form.cycle;
      if (!this.editExerciseMode) {
        form.date = date.clone().toDate();
      } else {
        form.date = this.editExercise.date;
      }

      // CH-4004
      form.utcDate = parseInt(date.clone().format("YYYYMMDD"), 10);
    }

    //CH-980
    if (this.editExerciseMode) {
      form.date = this.editExercise.originalDate;
      // CH-4004
      form.utcDate = parseInt(
        moment.utc(this.editExercise.originalDate).format("YYYYMMDD"),
        10
      );
    }

    let exercise = validateExercise(form, this.context.locals);

    if (exercise?.type === "assistant" && exercise?.sets?.length > 0) {
      exercise.sets.map((set) => {
        set.percentRepMax = 0;
      });
    }

    const search = exercise.exerciseMovement || exercise.secondary;
    const exLibrary =
      this.context.locals.activeUserToRequest.exerciseLibrary.assistant.find(
        (elem) => elem.movement === search
      );

    if (
      (exercise && exercise.parameters) ||
      (exLibrary && exLibrary.parameters)
    ) {
      exercise = this.addExtraPropertiesToExercise(
        Object.assign(exercise, { parameters: exLibrary.parameters })
      );
    } else {
      exercise = this.addExtraPropertiesToExercise(exercise);
    }

    if (exercise) {
      const { locals } = this.context;
      let movementLibrary = {};

      if (
        locals.query &&
        locals.query.athlete &&
        this.state.selectedExercise &&
        form.type != "primary"
      ) {
        const libraryCoach = get(
          locals.activeUserToRequest,
          `exerciseLibrary.${form.primary}`,
          []
        );
        const existsCoach = libraryCoach.find(
          (item) => item.movement === form.secondary
        );
        if (existsCoach) {
          existsCoach.repMaximum = form.secondaryRepMaximum;
          existsCoach.primary = form.primary;
          movementLibrary = existsCoach;
        }
      }
      submit(
        `/actions/exercise/save/${
          this.state.editExerciseMode ? this.editExercise._id : ""
        }?proxyAthlete=${this.locals.query.athlete}&reqSource=${
          this.props.reqSource
        }`,
        {
          method: "POST",
          body: Object.assign(exercise, {
            movementLibrary,
            organizationCoach: this.locals.activeUserToRequest._id,
          }),
        }
      );
    }
  }

  addExtraPropertiesToExercise(exercise) {
    const { selectedExercise } = this.state;

    if (selectedExercise) {
      return {
        ...exercise,
        video: selectedExercise.video,
        instructions: selectedExercise.instructions,
        exerciseTypeField: selectedExercise.exerciseTypeField,
        primaryMuscleGroup: selectedExercise.primaryMuscleGroup,
        secondaryMuscleGroup: selectedExercise.secondaryMuscleGroup,
        parameters: selectedExercise.parameters,
      };
    } else if (exercise?.type === "primary") {
      return this.addExtraPropertiesToPrimaryExercise(exercise);
    } else {
      return exercise;
    }
  }

  addExtraPropertiesToPrimaryExercise(exercise) {
    const primaryExercises = get(
      this.context.locals.activeUserToRequest,
      "primaryExercises"
    );
    if (primaryExercises && primaryExercises[exercise.primary]) {
      return {
        ...exercise,
        video: primaryExercises[exercise.primary].video,
        instructions: primaryExercises[exercise.primary].instructions,
        exerciseTypeField: primaryExercises[exercise.primary].exerciseTypeField,
        primaryMuscleGroup:
          primaryExercises[exercise.primary].primaryMuscleGroup,
        secondaryMuscleGroup:
          primaryExercises[exercise.primary].secondaryMuscleGroup,
      };
    }
    return exercise;
  }

  handleUnitChange(e, isEditSet) {
    let {
      target: { name, value },
    } = e;
    const currentSet = isEditSet ? this.state.editSet : this.state.newSet;
    if (!currentSet.units)
      currentSet.units = {
        defaultRepMax: this.locals.activeUser.units,
        load: this.locals.activeUser.units,
        equippedRepMax: this.locals.activeUser.units,
      };
    name = name.split("[")[1].split("]")[0];

    // Enforce load and equipped rep max to be the same as the user's defaults
    if (name === "load" || name === "equippedRepMax") {
      const currentUnits = currentSet.units[name] === "imperial" ? "lb" : "kg";
      if (currentSet.units[name] !== value) {
        // Only update if there is a change
        const newUnits = currentUnits === "lb" ? "kg" : "lb";

        if (name === "load") {
          const newValue = lround(
            convert(
              document.getElementById(
                isEditSet ? "exerciseEditWeightLoad" : "exerciseAddWeightLoad"
              ).value
            )
              .from(currentUnits)
              .to(newUnits),
            2
          );
          document.getElementById(
            isEditSet ? "exerciseEditWeightLoad" : "exerciseAddWeightLoad"
          ).value = newValue;
        } else {
          const newValue = lround(
            convert(document.getElementById("equippedRepMaxNew").value)
              .from(currentUnits)
              .to(newUnits),
            2
          );
          document.getElementById("equippedRepMaxNew").value = newValue;
        }
      }
    }
    // Update displayed default rep max value when changing units
    if (name === "defaultRepMax") {
      const currentUnits =
        currentSet.units["defaultRepMax"] === "imperial" ? "lb" : "kg";
      if (currentSet.units["defaultRepMax"] != value) {
        // Only update if there is a change
        const newUnits = currentUnits === "lb" ? "kg" : "lb";
        const newRepMax = this.locals.activeUserToRequest.round
          ? lround(
              convert(document.getElementById("defaultRepmaxUnitInput").value)
                .from(currentUnits)
                .to(newUnits),
              0
            )
          : lround(
              convert(document.getElementById("defaultRepmaxUnitInput").value)
                .from(currentUnits)
                .to(newUnits),
              2
            );
        document.getElementById("defaultRepmaxUnitInput").value = newRepMax;
      }
    }

    // Update displayed secondary rep max value when changing units
    if (name === "newRepMax") {
      name = "defaultRepMax"; // reusing defaultRepMax stored on state.
      const currentUnits =
        currentSet.units["defaultRepMax"] === "imperial" ? "lb" : "kg";
      if (currentSet.units["defaultRepMax"] !== value) {
        // Only update if there is a change
        const newUnits = currentUnits === "lb" ? "kg" : "lb";
        const newRepMax = lround(
          convert(document.getElementById("newRMUnitInput").value)
            .from(currentUnits)
            .to(newUnits),
          2
        );
        document.getElementById("newRMUnitInput").value = newRepMax;

        // Setting the value for the units and updating newMovementRM
        currentSet.units["defaultRepMax"] = value;
        this.setState({ newMovementRM: newRepMax });
      }
    }

    currentSet.units[name] = value;
    if (!isEditSet) this.setState({ newSet: currentSet });
    if (isEditSet) this.setState({ editSet: currentSet });

    // hack attempt to solve the radio button firing once issue. See https://github.com/facebook/react/issues/4930
    // although there is no preventdefault() here. Explicitly returning true may be the answer
    return true;
  }

  handlePreferredLoadInputChange({ target: { name, value } }) {
    this.setState({ preferredLoadInput: value });
  }

  confirmLeavePage(e) {
    const result = confirm(
      "Are you sure you would like to leave this page? All unsaved changes will be lost."
    );
    if (!result) e.preventDefault();
  }

  handleMovementChange(e) {
    // resetting newSet.load so user inputs it fresh to avoid confusion of carried over values
    const { form, newSet } = this.state;
    const { value, label } = e.target;

    if (form?.type !== "assistant") {
      newSet.load = newSet.percentRepMax = 0;

      document.getElementById("exerciseAddWeightLoad").value = newSet.load;
      document.getElementById("exerciseAddLoad").value = newSet.percentRepMax;
    }

    this.setState({
      form: Object.assign(form, {
        secondaryValue: value,
        secondary: value.split("{")[0],
        selectedLabel: label,
      }),
      newSet,
    });

    this.handleChange(e);
  }

  handleCancel(e) {
    // Push the cancel button, confirm that work will be lost if any work has been done
    e.preventDefault();
    if (
      !this.state.hasSetChanged ||
      confirm(
        "Are you sure you would like to leave this page? All unsaved changes will be lost."
      )
    ) {
      submit(`/actions/refresh/`, {
        method: "GET",
        body: { modal: "", editMode: "" },
      });
    }
  }

  handleReorderSet(step, setIndex) {
    const form = this.state.form;
    const sets = form.sets;
    // splice out the set from the array of sets
    const movedSet = sets.splice(setIndex, 1)[0];
    // put the set back in its new place
    // TODO: validate new place is possible -1 < possible < sets.length
    sets.splice(setIndex + step, 0, movedSet);
    // ensure form is updated. Ideally the below line should be implicit but just making sure.
    form.sets = sets;

    this.setState({ form });
  }

  buildMovementOptionsArray() {
    const { activeUserToRequest } = this.context.locals;
    const {
      squat,
      bench,
      deadlift,
      assistant,
      clean = [],
      jerk = [],
      snatch = [],
      overheadPress = [],
      other = [],
    } = activeUserToRequest.exerciseLibrary;
    const movementOptions = [
      {
        value: "squat",
        label: "Squat",
        movementPrimary: "squat",
        type: "primary",
      },
      {
        value: "bench",
        label: "Bench",
        movementPrimary: "bench",
        type: "primary",
      },
      {
        value: "deadlift",
        label: "Deadlift",
        movementPrimary: "deadlift",
        type: "primary",
      },
      {
        value: "clean",
        label: "Clean",
        movementPrimary: "clean",
        type: "primary",
      },
      {
        value: "jerk",
        label: "Jerk",
        movementPrimary: "jerk",
        type: "primary",
      },
      {
        value: "snatch",
        label: "Snatch",
        movementPrimary: "snatch",
        type: "primary",
      },
      {
        value: "overheadPress",
        label: "Overhead Press",
        movementPrimary: "overheadPress",
        type: "primary",
      },
    ];

    squat.forEach((item) => {
      movementOptions.push({
        value: item.movement + "{squat}",
        label: item.movement + " " + "(Squat)",
        movementPrimary: "squat",
        type: "secondary",
      });
    });
    bench.forEach((item) => {
      movementOptions.push({
        value: item.movement + "{bench}",
        label: item.movement + " " + "(Bench)",
        movementPrimary: "bench",
        type: "secondary",
      });
    });
    deadlift.forEach((item) => {
      movementOptions.push({
        value: item.movement + "{deadlift}",
        label: item.movement + " " + "(Deadlift)",
        movementPrimary: "deadlift",
        type: "secondary",
      });
    });
    clean.forEach((item) => {
      movementOptions.push({
        value: item.movement + "{clean}",
        label: item.movement + " ",
        movementPrimary: "clean",
        type: "secondary",
      });
    });
    jerk.forEach((item) => {
      movementOptions.push({
        value: item.movement + "{jerk}",
        label: item.movement + " ",
        movementPrimary: "jerk",
        type: "secondary",
      });
    });
    snatch.forEach((item) => {
      movementOptions.push({
        value: item.movement + "{snatch}",
        label: item.movement + " ",
        movementPrimary: "snatch",
        type: "secondary",
      });
    });
    overheadPress.forEach((item) => {
      movementOptions.push({
        value: item.movement + "{overheadPress}",
        label: item.movement + " " + "(Overhead Press)",
        movementPrimary: "overheadPress",
        type: "secondary",
      });
    });
    other.forEach((item) => {
      movementOptions.push({
        value: item.movement + "{other}",
        label: item.movement,
        movementPrimary: "other",
        type: "secondary",
      });
    });
    assistant.forEach((item) => {
      movementOptions.push({
        value: item.movement + "{assistant}",
        label: item.movement,
        movementPrimary: "assistant",
        type: "assistant",
      });
    });

    return movementOptions;
  }

  handleNewFieldsInputChange(event) {
    const { value, name } = event.target;

    this.setState((prevState) => ({
      newExerciseFields: { ...prevState.newExerciseFields, [name]: value },
    }));
  }

  handleParameterInputChange(event) {
    let { value, name } = event.target;

    if (["load", "loadDrop"].indexOf(name) > -1) {
      if (String(value).includes(",")) {
        value = event.target.value = String(value).replace(/,/g, ".");
      }
    }

    this.setState(
      (prevState) => ({
        parametersForm: { ...prevState.parametersForm, [name]: value },
      }),
      () => {
        const { selectedExercise, parametersForm } = this.state;

        //validate set
        this.setState({
          isNewSetValid: prevalidateOtherSet(selectedExercise, parametersForm),
        });
      }
    );
  }

  validateAddSecondary() {
    const { newMovement } = this.state;

    return newMovement;
  }

  validateAddSecondaryParameters() {
    const {
      newExerciseFields: { parameters },
      form: { basicExerciseType },
    } = this.state;

    return (
      basicExerciseType === "powerliftingExercise" ||
      parameters.findIndex((elem) => elem != NONE) > -1
    );
  }

  render() {
    const { editExercise } = this;
    const { locals } = this.context;
    const {
      activeUser,
      activeUserToRequest,
      organizationPermissions: globalOrganizationPermissions = [],
    } = locals;
    const {
      defaultRepMax,
      editExerciseMode,
      preferredLoadInput,
      form,
      hasSetChanged,
      updateEnabled,
      newSet,
      updateRMPrompt,
      isNewSetValid,
      editSet,
      editSetBackup,
      selectInput,
      addingFromSelect,
      addingMovementToLibrary,
      newExerciseFields: {
        freeFormSelected,
        parameters,
        videoFile,
        videoOriginal,
        videoUrl,
        exerciseTypeField,
        primaryMuscleGroup,
        secondaryMuscleGroup,
        instructions,
      },
      selectedExercise,
      newMovement,
    } = this.state;
    const {
      primary,
      sets,
      secondaryValue,
      secondaryRepMaximum,
      type: exerciseType,
      basicExerciseType,
      selectedLabel,
    } = form;
    const { organizationPermissions = [], organizationId } = activeUser;
    const isAssistant = exerciseType === "assistant";
    const movementOptions = this.buildMovementOptionsArray();
    // Set the value for movement name depending if addingFromSelect or typing new value
    const movementName = addingFromSelect
      ? { value: selectInput }
      : { value: newMovement };
    let isSecondaryDisabled = true;

    if (addingMovementToLibrary)
      isSecondaryDisabled = !this.validateAddSecondary();

    const intensityMeasure =
      get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
        ? "RPE"
        : "RiR";
    const isRiR = intensityMeasure === "RiR";

    const userOrganizationPermission =
      organizationPermissions.length > 0
        ? getPermissionNamesByIds(
            globalOrganizationPermissions,
            organizationPermissions
          )
        : [""];

    const userOrganizationCanAccessToExerciseLibrary =
      !organizationId ||
      (!!organizationId &&
        userOrganizationPermission.includes("Exercise Library"));

    const showRM =
      (this.locals.pathname.includes("athlete-portal/calendar") &&
        secondaryValue !== "" &&
        form?.type !== "assistant") ||
      (this.locals.athlete &&
        !this.locals.pathname.includes("athlete-portal/calendar") &&
        this.locals.pathname.includes("athlete-portal/programs/edit-program") &&
        secondaryValue !== "" &&
        form?.type !== "assistant") ||
      this.locals.pathname.includes("/dashboard/calendar");
    const isEditing = !!this.state.editSet && !!this.state.editingSet;
    const newMovementRMValue =
      form.basicExerciseType === "basicExercise" ? 0 : defaultRepMax;

    return (
      <Modal
        toClear={[
          "movement",
          "editMode",
          "programSession",
          "programWeek",
          "secondaryAdded",
        ]}
        onClose={hasSetChanged ? this.confirmLeavePage : null}
        title={editExerciseMode ? "Edit Exercise" : "Add Exercise"}
        className="Add-Exercise"
      >
        {addingMovementToLibrary ? (
          <form
            onSubmit={(e) => {
              if (!this.validateAddSecondaryParameters()) {
                alert("You must specify at least one parameter");
                e.preventDefault();
                return;
              }

              this.handleSaveToLibrary();
            }}
            id="add-exercise-form"
            action="/actions/user/add-secondary"
            encType="multipart/form-data"
            method="POST"
            data-noreset
          >
            <input
              type="hidden"
              name="movement"
              value={addingFromSelect ? selectInput : newMovement}
            />
            <input
              type="hidden"
              name="repMaximum"
              value={
                newSet.units.defaultRepMax === "imperial"
                  ? convert(parseFloat(newMovementRMValue)).from("lb").to("kg")
                  : parseFloat(newMovementRMValue)
              }
            />
            <AddLibraryExercise
              basicExerciseType={basicExerciseType}
              handleChange={this.handleChange}
              movementName={movementName}
              handleNewMovementChange={(newMovement) =>
                this.setState({
                  addingFromSelect: false,
                  newMovement,
                })
              }
              primary={primary}
              videoUrl={videoUrl}
              videoFile={videoFile}
              videoOriginal={videoOriginal}
              exerciseTypeField={exerciseTypeField}
              primaryMuscleGroup={primaryMuscleGroup}
              secondaryMuscleGroup={secondaryMuscleGroup}
              instructions={instructions}
              handleNewFieldsInputChange={this.handleNewFieldsInputChange}
              parameters={parameters}
              freeFormSelected={freeFormSelected}
              updateOtherExerciseParameters={this.updateOtherExerciseParameters}
              intensityMeasure={intensityMeasure}
              isRiR={isRiR}
              onDiscard={() =>
                this.setState({
                  addingMovementToLibrary: false,
                })
              }
              isSecondaryDisabled={isSecondaryDisabled}
            />
          </form>
        ) : (
          <form onSubmit={(e) => this.handleSubmit(e)} id="add-exercise">
            <div className="body">
              <div className="form-row">
                <div className="form-row-item basis-3/5">
                  <label>Select an existing exercise</label>
                  <SearchDropdown
                    options={movementOptions}
                    placeholder="Select Exercise"
                    handleChange={(val) => {
                      if (val) {
                        val.name = "exerciseMovement";
                        const e = { target: val };

                        return this.handleMovementChange(e);
                      }
                    }}
                    value={selectedLabel || secondaryValue.split("{")[0]}
                  />
                </div>

                <div
                  className={
                    showRM
                      ? `form-row-item basis-2/5${
                          updateEnabled || updateRMPrompt ? " hide-units" : ""
                        }`
                      : "hidden"
                  }
                >
                  <label htmlFor="defaultRepMax">1RM</label>
                  <UnitInput
                    tabIndex="0"
                    metric="kg"
                    imperial="lb"
                    name="defaultRepMax"
                    id="defaultRepmaxUnitInput"
                    defaultValue={
                      !this.locals.athlete
                        ? 100
                        : lround(
                            defaultRepMax !== 0 && secondaryRepMaximum === 0
                              ? defaultRepMax
                              : secondaryRepMaximum,
                            2
                          )
                    }
                    needToRound={this.locals.activeUserToRequest.round}
                    onProgramEditor={true}
                    units={newSet.units["defaultRepMax"]}
                    handleUnitChange={this.handleUnitChange}
                    type="number"
                    min={0}
                    step=".01"
                    onInput={this.handleRMChange}
                  />
                  {updateEnabled && (
                    <div className="edit-confirm">
                      <button
                        onClick={(e) => this.handleRMUpdate(e)}
                        data-button-type="primary"
                      >
                        Save
                      </button>
                      <button
                        onClick={(e) => this.handleRMDismiss(e)}
                        data-button-type="secondary"
                      >
                        <SvgIcon src="/img/new-icons/red-cross.svg" />
                      </button>
                    </div>
                  )}
                  {updateRMPrompt && (
                    <div className="edit-confirm">
                      <button
                        onClick={(e) => this.handleUpdateExerciseRM(form, e)}
                        data-button-type="primary"
                      >
                        Save
                      </button>
                      <button
                        onClick={(e) => this.handleUpdateExerciseRMDismiss(e)}
                        data-button-type="secondary"
                      >
                        <SvgIcon
                          src="/img/new-icons/red-cross.svg"
                          noFilterOnLight={true}
                        />
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="group alt-add-sets">
                <AddExerciseSets
                  selectedExercise={selectedExercise}
                  primary={primary}
                  sets={sets}
                  locals={locals}
                  handleReorderSet={this.handleReorderSet}
                  handleSetEditModeToggle={this.handleSetEditModeToggle}
                  handleRemoveSet={this.handleRemoveSet}
                  editSetBackup={editSetBackup}
                  intensityMeasure={intensityMeasure}
                  isRiR={isRiR}
                  exerciseType={exerciseType}
                  secondaryRepMaximum={secondaryRepMaximum}
                  activeUser={activeUser}
                  isEditing={isEditing}
                  activeUserToRequest={activeUserToRequest}
                  defaultRepMax={defaultRepMax}
                />

                {isEditing ? (
                  <EditSetRow
                    editSet={cloneDeep(editSet)}
                    defaultRepMax={defaultRepMax}
                    form={cloneDeep(form)}
                    formSets={cloneDeep(sets)}
                    setIndex={editSet.idx}
                    handleEditSetChange={this.handleEditSetChange}
                    handleUpdateSet={this.handleUpdateSet}
                    handleUnitChange={this.handleUnitChange}
                    isAssistant={isAssistant}
                    activeUser={this.activeUser}
                    preferredLoadInput={preferredLoadInput}
                    setPreferredLoadInput={(value) => {
                      this.setState((prevState) => {
                        const { editSet } = prevState;
                        if (value === "drop") {
                          editSet.load = 0;
                          editSet.percentRepMax = 0;
                        }
                        return {
                          preferredLoadInput: value,
                          editSet,
                        };
                      });
                    }}
                    primary={primary}
                    selectedExercise={selectedExercise}
                  />
                ) : (
                  <AddSetRow
                    primary={primary}
                    selectedExercise={selectedExercise}
                    handleNewSetChange={this.handleNewSetChange}
                    isRiR={isRiR}
                    intensityMeasure={intensityMeasure}
                    isAssistant={isAssistant}
                    handleUnitChange={this.handleUnitChange}
                    newSet={newSet}
                    preferredLoadInput={preferredLoadInput}
                    setPreferredLoadInput={(value) => {
                      this.setState((prevState) => {
                        const { newSet } = prevState;
                        if (value === "drop") {
                          newSet.load = 0;
                          newSet.percentRepMax = 0;
                        }
                        return {
                          preferredLoadInput: value,
                          newSet,
                        };
                      });
                    }}
                    isNewSetValid={isNewSetValid}
                    handleAddSet={this.handleAddSet}
                    handleParameterInputChange={this.handleParameterInputChange}
                    activeUser={activeUser}
                    parametersForm={this.state.parametersForm}
                  />
                )}
              </div>

              <div className="form-row">
                <div className="form-row-item">
                  <label htmlFor="notes">Notes</label>
                  <textarea
                    tabIndex="0"
                    name="notes"
                    defaultValue={editExerciseMode ? editExercise.notes : ""}
                    onChange={this.handleChange}
                    placeholder="Enter some note here e.g. (tempo, length of pause, coaching cues)"
                  />
                </div>
              </div>
            </div>

            <footer>
              {userOrganizationCanAccessToExerciseLibrary ? (
                <a
                  tabIndex="0"
                  role="button"
                  data-button-type="secondary"
                  onClick={() =>
                    this.setState({
                      addingMovementToLibrary: true,
                      newMovementRM: lround(defaultRepMax, 2),
                      form: Object.assign(form, {
                        primary: "squat",
                      }),
                    })
                  }
                >
                  Create new exercise
                </a>
              ) : (
                <div className="invisible" />
              )}

              <div className="flex gap-2">
                <button
                  data-button-type="secondary"
                  onClick={(e) => this.handleCancel(e)}
                  className="!text-[--danger]"
                >
                  Cancel
                </button>
                <button
                  data-button-type="primary"
                  onClick={(e) =>
                    sets.length && !this.state.editingSet
                      ? this.handleSubmit(e)
                      : this.triggerWarning(e)
                  }
                  disabled={!sets.length || this.state.editingSet}
                >
                  Save
                </button>
              </div>
            </footer>
          </form>
        )}
      </Modal>
    );
  }
}

AddExerciseModal.contextTypes = { locals: PropTypes.object };

export default AddExerciseModal;
